/**
 * These settings are meant to be persistet through one configuration session.
 */
export class PrewallFilterSettings {
    /** Specific attributes to filter for. */
    public attributeFilter: { [attribute: string]: boolean };

    constructor() {
        this.reset();
    }

    public reset() {
        this.attributeFilter = {};
    }
}



// WEBPACK FOOTER //
// ./src/app/configure/configure-prewall/PrewallFilterSettings.ts